import { defineStore } from "pinia";

/**
 * Creates a pinia store to hold a reactive instance of a type
 * @param name The name of the pinia store, must be unique
 * @param type A class Type or an anonymous class definition in the form of 'class { props/functions }'
 * @param args Optional args to be passed to the class constructor
 * @returns 
 */
export function useStore<TStore>( name: string, type: { new( ...args : any[]): TStore }, ...args: any[] ): TStore 
{
    const piniaStore = defineStore( name, () => 
    {
        const instance = new type( ...args );
        return { instance }
    }) as any as () => { instance: TStore };
    return piniaStore().instance; // instance will be reactive
}